import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import MDBox from 'components/MDBox';
import DashboardNavbar from '../../examples/Navbars/DashboardNavbar';
import DashboardLayout from '../LayoutContainers/DashboardLayout';
import { UsersList } from 'components/UsersList/UsersList';

export const ManageUsers = () => {
  const dispatch = useDispatch();

  return (
    <DashboardLayout>
      <DashboardNavbar objectName={'Manage users'} />
      <Typography
        fontSize="11px"
        sx={{
          paddingLeft: { xs: 0, sm: '12px' },
          marginTop: { xs: '-15px', sm: '-5px' },
          textAlign: { xs: 'center', sm: 'left' },
        }}>
        Smart indoor air monitoring & management platform
      </Typography>
      <MDBox
        className="body-container"
        sx={{
          p: 0,
          minHeight: 'calc(100dvh - 84px)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'auto',
        }}>
        <UsersList />
      </MDBox>
    </DashboardLayout>
  );
};

export default ManageUsers;
